import baseApi from "@/api/baseApi";
import { transformDownload } from "@/helpers/saveFile";

const api = {
  async getChecklists(data) {
    const response = await baseApi({
      method: "post",
      url: `/checklists`,
      data: data,
    });

    return response.data;
  },

  async getChecklistsCount(data) {
    const response = await baseApi({
      method: "post",
      url: `/checklists/count`,
      data: data,
    });

    return response.data;
  },

  async getFilteroptions() {
    const response = await baseApi({
      method: "get",
      url: `/checklists/filteroptions`,
      data: { hideLoader: true },
    });

    return response.data;
  },
  async getChecklist(data) {
    const response = await baseApi({
      method: "post",
      url: `/checklist`,
      data: data,
    });

    return response.data;
  },
  async saveChecklist(data) {
    const response = await baseApi({
      method: "post",
      url: `/checklist/context/save`,
      data: data,
    });

    return response.data;
  },
  async downloadChecklistPdf(
    checkListId: number,
    signature?: Array<any>,
    includeAttachments?: boolean
  ) {
    const response = await baseApi({
      method: "post",
      url: `/checklist/download/pdf`,
      responseType: "blob",
      data: {
        checkListId: checkListId,
        base64Signature: signature,
        includeAttachments: includeAttachments,
      },
      transformResponse: transformDownload,
    });

    return response.data;
  },
  async getChecklistsProjects(projectId) {
    const response = await baseApi({
      method: "get",
      url: `/checklists/project/${projectId}`,
    });

    return response.data;
  },
  async generateChecklist(data) {
    const response = await baseApi({
      method: "post",
      url: `/checklist/generate`,
      data: data,
    });

    return response.data;
  },
};

export default api;
